module.exports = __webpack_public_path__ + "img/rgs-search-logo.6f0977d.gif";